import { getNumRows } from '../../../Utils/Common.js';
import * as TYPES from '../../types.js';
import {
    ToastSuccess,
    ToastDanger,
    ToastWarning,
    SwalWarningHtml,
    SwalWarning,
} from '../../../Services/_toast.service';
import { SwalWarningStock } from '../../../Services/_swal.service';
import $ from 'jquery';
import { blockRoute, setMUIPage } from '../helper/helper.actions';
import { ExpiryService } from './_service.expiry.js';

const spinLG =
    '<span class="spinner-border" role="status" aria-hidden="true"></span>';

// handle Inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: TYPES.EXPIRY_INPUT_CHANGE,
        payload: { name: e.target.name, value: e.target.value },
    });
};

// handle search
export const handleSearchInput = (e) => async (dispatch) => {
    dispatch({ type: TYPES.SEARCH_INPUT, payload: e.target.value });
};

// loading
export const setLoading = (status) => async (dispatch) =>
    dispatch({ type: TYPES.SET_LOADING, payload: status });
export const setMiniLoading = (status) => async (dispatch) =>
    dispatch({ type: TYPES.SET_MINI_LOADING, payload: status });

// clear data
export const clearExpiry = () => async (dispatch) =>
    dispatch({ type: TYPES.CLEAR_EXPIRY });

// set page
export const setPage =
    (page, status = true) =>
    async (dispatch) => {
        dispatch({ type: TYPES.SET_PAGE, payload: { page, status } });
    };

// handle change expiry view (all, expiring_soon, expired)
export const handleChangeExpiryView = (view) => async (dispatch) => {
    dispatch({
        type: TYPES.EXPIRY_CHANGE_VIEW,
        payload: view,
    });
    dispatch(setMUIPage(1));
    dispatch(getExpiry(1));
};

// fetch product with expiry
export const getExpiry =
    (pageNumber, rows_per_page = null) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));
        let {
            search,
            pagination,
            sort_order_name,
            sort_order_direction,
            date_from,
            date_to,
            date_filter,
            expiry_view,
        } = getState().expiry;
        let rows_per_page_val =
            rows_per_page != null ? rows_per_page : getNumRows('expiry');

        let searchPostParams = {
            // search: search,
            // activePage: pagination.activePage,
            // page: pageNumber,
            // rows_per_page: rows_per_page_val,
            // sort_order_name: sort_order_name,
            // sort_order_direction: sort_order_direction
            search,
            expiry_view: expiry_view,
            options: {
                page: pageNumber ? pageNumber : pagination.activePage,
                limit: rows_per_page_val ? rows_per_page_val : 10,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        if (date_filter) {
            searchPostParams.date_from = date_from;
            searchPostParams.date_to = date_to;
        }

        ExpiryService.getExpiry(searchPostParams)
            .then((res) => {
                dispatch({
                    type: TYPES.GET_EXPIRIES,
                    payload: {
                        expiries: res.data.docs,
                        pagination: {
                            //   totalCount: res.data.expiries.total,
                            //   activePage: res.data.expiries.current_page,
                            //   itemsCountPerPage: res.data.expiries.per_page,
                            //   totalItemsCount: res.data.expiries.total,
                            totalCount: res.data.total_docs,
                            activePage: res.data.page,
                            itemsCountPerPage: res.data.limit,
                            totalItemsCount: res.data.total_docs,
                        },
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((error) => {
                // if (error.data.errors.length > 0) {
                //   error.data.errors.map((err) => ToastDanger(err));
                // } else {
                //   ToastDanger("Network error, please reload the page.");
                // }
                dispatch(setLoading(false));

                // $(".btn-save").removeAttr("disabled").html("Save");
                console.log(error);
            });
    };

// fetch single expiries
export const getSingleExpiry =
    (id, status = null) =>
    async (dispatch) => {
        if (!status) {
            dispatch(setLoading(true));
        }

        ExpiryService.getSingleExpiry(id)
            .then((res) => {
                dispatch({
                    type: TYPES.GET_SINGLE_SUPPLIER,
                    payload: res.data.supplier,
                });
                dispatch({
                    type: TYPES.SET_PAYMENT_DETAILS,
                    payload: res.data.supplier.account_details
                        ? res.data.supplier.account_details
                        : [],
                });

                // if (status == 'delete') {
                //     dispatch(archive());
                // }

                if (status == 'history') {
                    let id_params = { supplier_id: id };
                    // dispatch(getPurchaseOrders(1, id_params));
                }

                if (!status) {
                    dispatch(setLoading(false));
                }
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }

                // $(".btn-save").removeAttr("disabled").html("Save");
                console.log(error);
                // ToastDanger("Network error, please reload the page.");
                // console.log(error);
                if (!status) {
                    dispatch(setLoading(false));
                }
            });
    };

// date input onchange
export const dateFilterInput = (e) => async (dispatch) => {
    dispatch({
        type: TYPES.EXPIRY_HISTORY_DATE_FILTER_INPUT,
        payload: { key: [e.target.name], value: e.target.value },
    });
};

// HANDLE SUBMIT DATE FILTER FOR [ PURCHASE ORDER, PRODUCTS ]
export const handleDateFilterSubmit = (e) => async (dispatch, getState) => {
    e.preventDefault();

    let { date_to, date_from } = getState().expiry;

    try {
        if (new Date(date_from).getTime() > new Date(date_to).getTime()) {
            ToastDanger('Date From cannot be greater than Date To.');
        } else {
            dispatch({
                type: TYPES.EXPIRY_SET_DATE_FILTER,
                payload: true,
            });
            dispatch(getExpiry(1));
        }
    } catch (error) {
        console.log(`Error: ${error}`);
        ToastDanger('Something went wrong please contact your admin...');
    }
};

// DATE INPUT CLEAR
export const dateFilterClear = () => async (dispatch) => {
    dispatch({
        type: TYPES.EXPIRY_HISTORY_DATE_INPUT_CLEAR,
    });
    dispatch(getExpiry(1));
};

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        // console.log(selectedRows, currentRows)
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });
        // console.log(newArray);
        dispatch({ type: TYPES.GET_ROWS_TO_DELETE, payload: newArray });
    };

// export const confirmDeleteDialogBox = () => async (dispatch, getState) => {
//     let { rows_to_delete } = getState().customer;
//     let names = '';
//     let name_arr = [];
//     rows_to_delete.map((rows, i) => {
//         name_arr.push('<b>' + rows.name + '</b>');
//     });
//     names = name_arr.join(', ');

//     SwalWarningHtml(
//         'Warning!',
//         `Do you want to remove the Expiry(s): ${names}?`,
//         () => dispatch(moveToArchives())
//     );
// };

// Sort by column name and direction
export const sortTableByColumn =
    (sort_order_name, sort_order_direction) => async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: TYPES.SORT_BY_COLUMN, payload: sortingParams });
        dispatch(getExpiry());
    };

export const handleSearchInputMUI = (e) => async (dispatch) => {
    dispatch({ type: TYPES.SEARCH_INPUT, payload: e.target.value });
    if (e.key === 'Enter') {
        console.log('enter');
        // dispatch(getPurchaseOrders(1));
    }
};

// set the rows checked box
export const setRowChecked = () => async (dispatch) =>
    dispatch({ type: TYPES.SET_ROW_CHECKED });

// Set Modal
export const setModal = (modal, status) => async (dispatch) => {
    if (modal === 'expiry_modal') {
        dispatch({
            type: TYPES.SET_EXPIRY,
            payload: true,
        });
    }
    dispatch({
        type: TYPES.SET_MODAL,
        payload: { modal, status },
    });
};

export const resetModalInputs = () => (dispatch) => {
    dispatch({
        type: TYPES.RETURN_CLEAR,
        payload: {
            qty: 0,
            remarks: '',
            supplier: null,
            expiry_item: [],
        },
    });
};

export const getProducts = (products) => async (dispatch) => {
    dispatch({
        type: TYPES.EXPIRY_GET_PRODUCTS,
        payload: { products: products },
    });
    dispatch(setModal('expiry_item_modal'));
};
